import React, { useState, useEffect } from "react";
import { TableContainer, Paper, TextField, Button } from "@mui/material";
import { Typography } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

// material-ui
import Box from "@mui/material/Box";

import { StaffuseAuth } from "../../../security/StaffuseAuth";
import SimpleTableHeader from "../../../components/Tables/SimpleTableHeader";
import SimpleTableCell from "../../../components/Tables/SimpleTableCell";

import { Get_Registers_Need_Reach_Part5_PostAssociations } from "./api/Get_Registers_Need_Reach_Part5_PostAssociations";
import { api_PostAssociations_Reach_Part5_AssocCheck_ContactIP } from "./api/api_PostAssociations_Reach_Part5_AssocCheck_ContactIP";
import { api_PostAssociations_Reach_Part5_AssocPost_ContactIP } from "./api/api_PostAssociations_Reach_Part5_AssocPost_ContactIP";
import { api_PostAssociations_Reach_Part5_AssocCheck_ContactEC } from "./api/api_PostAssociations_Reach_Part5_AssocCheck_ContactEC";
import { api_PostAssociations_Reach_Part5_AssocPost_ContactEC } from "./api/api_PostAssociations_Reach_Part5_AssocPost_ContactEC";
import { api_PostAssociations_Reach_Part5_AssocCheck_ContactOne } from "./api/api_PostAssociations_Reach_Part5_AssocCheck_ContactOne";
import { api_PostAssociations_Reach_Part5_AssocPost_ContactOne } from "./api/api_PostAssociations_Reach_Part5_AssocPost_ContactOne";
import { api_PostAssociations_Reach_Part5_AssocCheck_ContactTwo } from "./api/api_PostAssociations_Reach_Part5_AssocCheck_ContactTwo";
import { api_PostAssociations_Reach_Part5_AssocPost_ContactTwo } from "./api/api_PostAssociations_Reach_Part5_AssocPost_ContactTwo";

function REACH_Part5_PostAssociations() {
  const { logout } = StaffuseAuth();

  const [Registers, setRegisters] = useState([
    {
      BasicInfo: {
        First_Name: "NOT FOUND",
        Created_At: "2024-10-01",
        ProgrammeTitle: "Summer Programme",
        ProgrammeVarient: "In Person",
        ProgrammeDate: "(3rd November 2024)",
      },
      Notes: [
        {
          Note: "Arrival Departure Email Sent",
          DateTime: "2024-10-07T10:00:00Z",
        },
      ],
    },
  ]);

  useEffect(() => {
    Get_Registers_Need_Reach_Part5_PostAssociations({}, setRegisters, logout);
  }, []);

  async function PostAssociations_Reach_Part5_AssocCheck_ContactIP(
    e,
    Attendee
  ) {
   e.preventDefault();
  console.log(`Starting AssocCheck_ContactIP for ${Attendee._id}`);
  try {  
  let options = {
      Attendee: Attendee,
    };
    const response = await api_PostAssociations_Reach_Part5_AssocCheck_ContactIP(options, logout);
    console.log(`Success AssocCheck_ContactIP for ${Attendee._id}:`, response);

    //api_PostAssociations_Reach_Part5_AssocCheck_ContactIP(options, logout);
    console.log("-----End Send-----");
    //find this attendee in the registers and update
    const updatedRegisters = Registers.map((register) => {
      if (register._id === Attendee._id) {
        return {
          ...register,
          REACH: {
            ...register.REACH,
            AssocCheck_ContactIP: "Yes",
          },
        };
      }
      return register;
    });
    setRegisters(updatedRegisters);
    } catch (error) {
    console.error(`Error AssocCheck_ContactIP for ${Attendee._id}:`, error);
    // Don't update state on error
    throw error; // Re-throw to handle in calling function
  }
  }

  async function PostAssociations_Reach_Part5_AssocPost_ContactIP(e, Attendee) {
    e.preventDefault();
          console.log(`Starting AssocPost_ContactIP for ${Attendee._id}`);

          try {
    let options = {
      Attendee: Attendee,
    };
    const response = await api_PostAssociations_Reach_Part5_AssocPost_ContactIP(options, logout);
        console.log(`Success AssocPost_ContactIP for ${Attendee._id}:`, response);

    console.log("-----End Send-----");
    //find this attendee in the registers and update
    const updatedRegisters = Registers.map((register) => {
      if (register._id === Attendee._id) {
        return {
          ...register,
          REACH: {
            ...register.REACH,
            AssocPost_ContactIP: "Yes",
          },
        };
      }
      return register;
    });
    setRegisters(updatedRegisters);
    } catch (error) {
    console.error(`Error AssocPost_ContactIP for ${Attendee._id}:`, error);
    // Don't update state on error
    throw error; // Re-throw to handle in calling function
  }
  }

  async function PostAssociations_Reach_Part5_AssocCheck_ContactEC(
    e,
    Attendee
  ) {
    e.preventDefault();
    let options = {
      Attendee: Attendee,
    };
    api_PostAssociations_Reach_Part5_AssocCheck_ContactEC(options, logout);
    console.log("-----End Send-----");
    //find this attendee in the registers and update
    const updatedRegisters = Registers.map((register) => {
      if (register._id === Attendee._id) {
        return {
          ...register,
          REACH: {
            ...register.REACH,
            AssocCheck_ContactEC: "Yes",
          },
        };
      }
      return register;
    });
    setRegisters(updatedRegisters);
  }
  async function PostAssociations_Reach_Part5_AssocPost_ContactEC(e, Attendee) {
    e.preventDefault();
    let options = {
      Attendee: Attendee,
    };
    api_PostAssociations_Reach_Part5_AssocPost_ContactEC(options, logout);
    console.log("-----End Send-----");
    //find this attendee in the registers and update
    const updatedRegisters = Registers.map((register) => {
      if (register._id === Attendee._id) {
        return {
          ...register,
          REACH: {
            ...register.REACH,
            AssocPost_ContactEC: "Yes",
          },
        };
      }
      return register;
    });
    setRegisters(updatedRegisters);
  }
  async function PostAssociations_Reach_Part5_AssocCheck_ContactOne(
    e,
    Attendee
  ) {
    e.preventDefault();
    let options = {
      Attendee: Attendee,
    };
    await api_PostAssociations_Reach_Part5_AssocCheck_ContactOne(
      options,
      logout
    );
    console.log("-----End Send-----");
    //find this attendee in the registers and update
    const updatedRegisters = Registers.map((register) => {
      if (register._id === Attendee._id) {
        return {
          ...register,
          REACH: {
            ...register.REACH,
            AssocCheck_ContactOne: "Yes",
          },
        };
      }
      return register;
    });
    setRegisters(updatedRegisters);
  }
  async function PostAssociations_Reach_Part5_AssocPost_ContactOne(
    e,
    Attendee
  ) {
    e.preventDefault();
    let options = {
      Attendee: Attendee,
    };
    await api_PostAssociations_Reach_Part5_AssocPost_ContactOne(
      options,
      logout
    );
    console.log("-----End Send-----");
    //find this attendee in the registers and update
    const updatedRegisters = Registers.map((register) => {
      if (register._id === Attendee._id) {
        return {
          ...register,
          REACH: {
            ...register.REACH,
            AssocPost_ContactOne: "Yes",
          },
        };
      }
      return register;
    });
    setRegisters(updatedRegisters);
  }
  async function PostAssociations_Reach_Part5_AssocCheck_ContactTwo(
    e,
    Attendee
  ) {
    e.preventDefault();
    let options = {
      Attendee: Attendee,
    };
    await api_PostAssociations_Reach_Part5_AssocCheck_ContactTwo(
      options,
      logout
    );
    console.log("-----End Send-----");
    //find this attendee in the registers and update
    const updatedRegisters = Registers.map((register) => {
      if (register._id === Attendee._id) {
        return {
          ...register,
          REACH: {
            ...register.REACH,
            AssocCheck_ContactTwo: "Yes",
          },
        };
      }
      return register;
    });
    setRegisters(updatedRegisters);
  }
  async function PostAssociations_Reach_Part5_AssocPost_ContactTwo(
    e,
    Attendee
  ) {
    e.preventDefault();
    let options = {
      Attendee: Attendee,
    };
    await api_PostAssociations_Reach_Part5_AssocPost_ContactTwo(
      options,
      logout
    );
    console.log("-----End Send-----");
    //find this attendee in the registers and update
    const updatedRegisters = Registers.map((register) => {
      if (register._id === Attendee._id) {
        return {
          ...register,
          REACH: {
            ...register.REACH,
            AssocPost_ContactTwo: "Yes",
          },
        };
      }
      return register;
    });
    setRegisters(updatedRegisters);
  }

  //TODOCHANGE, change this as needed

  async function handleSendAll(e) {
    e.preventDefault();
    console.log("-----Start Send All-----");
    for (const Register of Registers) {
      await PostAssociations_Reach_Part5_AssocCheck_ContactTwo(e, Register);
      await new Promise((resolve) => setTimeout(resolve, 1000));
      await PostAssociations_Reach_Part5_AssocPost_ContactTwo(e, Register);
     await new Promise((resolve) => setTimeout(resolve, 2800));
    }
  }

//   import { api_PostAssociations_Reach_Part5_AssocCheck_ContactIP } from "./api/api_PostAssociations_Reach_Part5_AssocCheck_ContactIP";
// import { api_PostAssociations_Reach_Part5_AssocPost_ContactIP } from "./api/api_PostAssociations_Reach_Part5_AssocPost_ContactIP";
// import { api_PostAssociations_Reach_Part5_AssocCheck_ContactEC } from "./api/api_PostAssociations_Reach_Part5_AssocCheck_ContactEC";
// import { api_PostAssociations_Reach_Part5_AssocPost_ContactEC } from "./api/api_PostAssociations_Reach_Part5_AssocPost_ContactEC";
// import { api_PostAssociations_Reach_Part5_AssocCheck_ContactOne } from "./api/api_PostAssociations_Reach_Part5_AssocCheck_ContactOne";
// import { api_PostAssociations_Reach_Part5_AssocPost_ContactOne } from "./api/api_PostAssociations_Reach_Part5_AssocPost_ContactOne";
// import { api_PostAssociations_Reach_Part5_AssocCheck_ContactTwo } from "./api/api_PostAssociations_Reach_Part5_AssocCheck_ContactTwo";
// import { api_PostAssociations_Reach_Part5_AssocPost_ContactTwo } from "./api/api_PostAssociations_Reach_Part5_AssocPost_ContactTwo";

  //-----------------------------Return--------------------------------------------

  return (
    <div
      style={{
        backgroundColor: "#e5e5e5",
        minHeight: "93vh",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row", // Add this line
          flexWrap: "wrap",
          justifyContent: "flex-start",
          // gap: "20px",
          // height: "100%",
        }}
      >
        <div
          name="space"
          style={{ width: "100%", height: "10px", flex: "0 1 auto" }}
        ></div>
        <button onClick={(e) => handleSendAll(e)}>Send All</button>
        <Box
          component="main"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            maxWidth: "95%",
            maxHeight: "800px",
            flexGrow: 1,
            p: 1,
          }}
        >
          <Typography variant="h6" gutterBottom>
            REACH Post PostAssociation
          </Typography>

          <TableContainer
            component={Paper}
            sx={{
              width: "100%",
              margin: "0 auto",
              overflow: "auto",
            }}
          >
            <Table
              aria-label="simple table"
              sx={{
                border: "1px solid #e0e0e0",
                tableLayout: "fixed",
              }}
            >
              <TableHead>
                <TableRow>
                  <>{SimpleTableHeader("_id")}</>
                  <>{SimpleTableHeader("Name")}</>
                  <>{SimpleTableHeader("EC")}</>
                  <>{SimpleTableHeader("Reach ContactID")}</>
                  <>{SimpleTableHeader("ContactIPID")}</>
                  <>{SimpleTableHeader("MongoDB ContactIPID")}</>
                  <>{SimpleTableHeader("REACH ContactIPID")}</>
                  <>{SimpleTableHeader("ContactECID")}</>
                  <>{SimpleTableHeader("MongoDB ContactECID")}</>
                  <>{SimpleTableHeader("REACH ContactECID")}</>
                  <>{SimpleTableHeader("ContactOneID")}</>
                  <>{SimpleTableHeader("MongoDB ContactOneID")}</>
                  <>{SimpleTableHeader("REACH ContactOneID")}</>
                  <>{SimpleTableHeader("ContactTwoID")}</>
                  <>{SimpleTableHeader("MongoDB ContactTwoID")}</>
                  <>{SimpleTableHeader("REACH ContactTwoID")}</>
                </TableRow>
              </TableHead>
              <TableBody>
                {Registers.map((Register, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor:
                        Register?.MetaData?.Archived === "Yes"
                          ? "rgba(139, 0, 0, 0.5)"
                          : Register?.MetaData?.Reserved === "Yes"
                          ? "rgba(0, 0, 139, 0.5)"
                          : Register?.MetaData?.Bursary === "Yes"
                          ? "rgba(144, 238, 144, 0.5)"
                          : "",
                      "&:hover": {
                        backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                        "& .MuiTableCell-root": {
                          padding: "8px",
                          wordWrap: "break-word",
                          overflowWrap: "break-word", // Adjust padding here to make cells smaller
                        },
                      },
                    }}
                  >
                    {SimpleTableCell(Register?._id)}
                    {SimpleTableCell(Register?.BasicInfo?.First_Name)}
                    {SimpleTableCell(
                      Register?.IPInfo?.EC_ID &&
                        Register?.IPInfo?.EC_ID !== "" &&
                        Register?.IPInfo?.EC_ID !== null &&
                        Register?.IPInfo?.EC_ID !== undefined
                        ? "EC Booking"
                        : "Non EC Booking"
                    )}
                    {SimpleTableCell(Register?.REACH?.ContactID)}

                    {SimpleTableCell(Register?.REACH?.ContactIPID)}
                    {!Register.REACH?.AssocCheck_ContactIP ? (
                      <button
                        onClick={(e) =>
                          PostAssociations_Reach_Part5_AssocCheck_ContactIP(
                            e,
                            Register
                          )
                        }
                      >
                        Send
                      </button>
                    ) : (
                      SimpleTableCell("")
                    )}
                    {Register.REACH?.AssocCheck_ContactIP &&
                    !Register.REACH?.AssocPost_ContactIP ? (
                      <button
                        onClick={(e) =>
                          PostAssociations_Reach_Part5_AssocPost_ContactIP(
                            e,
                            Register
                          )
                        }
                      >
                        Send
                      </button>
                    ) : (
                      SimpleTableCell("")
                    )}

                    {SimpleTableCell(Register?.REACH?.ContactECID)}
                    {Register?.REACH?.AssocPost_ContactIP &&
                    !Register.REACH?.AssocCheck_ContactEC ? (
                      <button
                        onClick={(e) =>
                          PostAssociations_Reach_Part5_AssocCheck_ContactEC(
                            e,
                            Register
                          )
                        }
                      >
                        Send
                      </button>
                    ) : (
                      SimpleTableCell("")
                    )}
                    {Register.REACH?.AssocCheck_ContactEC &&
                    !Register.REACH?.AssocPost_ContactEC ? (
                      <button
                        onClick={(e) =>
                          PostAssociations_Reach_Part5_AssocPost_ContactEC(
                            e,
                            Register
                          )
                        }
                      >
                        Send
                      </button>
                    ) : (
                      SimpleTableCell("")
                    )}

                    {SimpleTableCell(Register?.REACH?.ContactOneID)}
                    {Register?.REACH?.AssocPost_ContactEC &&
                    !Register.REACH?.AssocCheck_ContactOne ? (
                      <button
                        onClick={(e) =>
                          PostAssociations_Reach_Part5_AssocCheck_ContactOne(
                            e,
                            Register
                          )
                        }
                      >
                        Send
                      </button>
                    ) : (
                      SimpleTableCell("")
                    )}
                    {Register.REACH?.AssocCheck_ContactOne &&
                    !Register.REACH?.AssocPost_ContactOne ? (
                      <button
                        onClick={(e) =>
                          PostAssociations_Reach_Part5_AssocPost_ContactOne(
                            e,
                            Register
                          )
                        }
                      >
                        Send
                      </button>
                    ) : (
                      SimpleTableCell("")
                    )}

                    {SimpleTableCell(Register?.REACH?.ContactTwoID)}
                    {Register?.REACH?.AssocPost_ContactOne &&
                    !Register.REACH?.AssocCheck_ContactTwo ? (
                      <button
                        onClick={(e) =>
                          PostAssociations_Reach_Part5_AssocCheck_ContactTwo(
                            e,
                            Register
                          )
                        }
                      >
                        Send
                      </button>
                    ) : (
                      SimpleTableCell("")
                    )}
                    {Register.REACH?.AssocCheck_ContactTwo &&
                    !Register.REACH?.AssocPost_ContactTwo ? (
                      <button
                        onClick={(e) =>
                          PostAssociations_Reach_Part5_AssocPost_ContactTwo(
                            e,
                            Register
                          )
                        }
                      >
                        Send
                      </button>
                    ) : (
                      SimpleTableCell("")
                    )}

                    {/* <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      <button onClick={(e) => handleSend(e, [Register])}>
                        Send
                      </button>
                    </TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>
    </div>
  );
}

export default REACH_Part5_PostAssociations;
